/* src/app/admin-setting/assing-company-users/company-users-list/access-levels/access-levels.component.css */
::ng-deep update-user-role-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
.popup-header {
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #ccc;
  margin-bottom: 1rem;
  color: #333;
}
.permission-list {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0;
}
mat-list-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e0e0e0;
}
.spacer {
  flex: 1;
  font-weight: 500;
  color: #444;
  text-transform: capitalize;
}
mat-checkbox {
  margin-left: 1rem;
}
mat-dialog-actions {
  padding: 1rem;
  border-top: 1px solid #ddd;
  background-color: #fafafa;
}
button[mat-button] {
  font-weight: 500;
}
.theme-button {
  font-weight: 600;
  text-transform: uppercase;
  padding: 0.5rem 1.5rem;
}
/*# sourceMappingURL=access-levels.component.css.map */
